import BubbleMain from './Bubble';
import BubbleButton from './BubbleButton';
import BubbleContent from './BubbleContent';
import BubbleStepper from './BubbleStepper';
import BubbleTitle from './BubbleTitle';

export const PaymentBubble = Object.assign(BubbleMain, {
  Title: BubbleTitle,
  Stepper: BubbleStepper,
  Content: BubbleContent,
  Button: BubbleButton
});

export default PaymentBubble;
